import { Accordion, AccordionItem as Item } from "@szhsin/react-accordion";
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { useState } from "react";
import { parsePoojaDescriptionRawHTML } from "@/utils/utils";
import parse from "html-react-parser";
const AccordionItem1 = ({
  header,
  content,
  index,
  expandedIndex,
  setExpandedIndex,
  ...rest
}) => {
  const isExpanded = index === expandedIndex;

  const handleToggle = () => {
    setExpandedIndex(isExpanded ? null : index);
  };

  return (
    <Item
      {...rest}
      header={
        <div
          className="flex justify-between items-center px-4 py-4 w-full text-start"
          onClick={handleToggle}
        >
          {header}
          <div className="relative w-4 h-4 flex-shrink-0">
            <ImageWrapper
              src="/icons/down-arrow-gray.svg"
              width={16}
              height={16}
              className={`transform transition duration-250 ${
                isExpanded ? "rotate-180" : ""
              }`}
            />
          </div>
        </div>
      }
      buttonProps={{
        className: `flex items-start border w-full rounded-lg border-[#475569] border-opacity-30 w-full text-base text-left text-[#475569] bg-transparent hover:bg-[#F1F1F1] ${
          isExpanded ? "bg-[#CBD5E140] " : ""
        }`,
      }}
      contentProps={{
        className:
          "transition duration-250 border text-justify text-sm border border-[#475569] rounded-lg p-4 border-opacity-30 text-Default tracking-tight md:tracking-normal leading-5 md:leading-6",
      }}
      panelProps={{ className: "pt-0" }}
    >
      {parse(parsePoojaDescriptionRawHTML(content))}
    </Item>
  );
};
const CustomAccordion2 = ({ items, className, ...accordionProps }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <Accordion
      className={`flex flex-col gap-4 ${className}`}
      {...accordionProps}
    >
      {items.map((item, index) => {
        const { itemType, ...itemProps } = item;
        return (
          <AccordionItem1
            key={index}
            index={index}
            expandedIndex={expandedIndex}
            setExpandedIndex={setExpandedIndex}
            {...itemProps}
            header={item.question}
            content={item.answer}
          />
        );
      })}
    </Accordion>
  );
};

export default CustomAccordion2;
